import { createErrorMessage, serviceBase } from "../../../service";
import { clearance } from "../../../service";
import api from "../../../api";
const TariffOperands = {
  ...serviceBase,
  clearance,
  resource: "operands",
  preList: function(params) {
    delete params.id;
    const tariffPlanId = extractProjectIdFromUrl() || "-";
    return `projects/${params.project_id || "-"}/tariff-plans/${tariffPlanId ||
      "-"}`;
  },
  preListOption: {
    getList: true,
    get: true,
    create: false,
    update: false,
    delete: false,
    deleteList: false
  },
  create(
    params = {},
    onSuccess = () => {},
    onError = () => {},
    errorHandler = () => {}
  ) {
    return api
      .post(`/projects/${params.project_id}/tariff-operands`, params)
      .then(res => {
        onSuccess(res.data);
        return res;
      })
      .catch(res => {
        createErrorMessage(res);
        errorHandler(res.response.data.errors);
        onError(res);
      });
  },
  delete(
    params = {},
    onSuccess = () => {},
    onError = () => {},
    errorHandler = () => {}
  ) {
    return api
      .delete(
        `/projects/${params.project_id}/tariff-operands/${params.id}`,
        params
      )
      .then(res => {
        onSuccess(res.data);
        return res;
      })
      .catch(res => {
        createErrorMessage(res);
        errorHandler(res.response.data.errors);
        onError(res);
      });
  }
};

export default TariffOperands;
function extractProjectIdFromUrl() {
  const urlPath = window.location.pathname;
  const pathSegments = urlPath.split("/");
  const projectIndex = pathSegments.indexOf("tariff-plans") + 1;
  return pathSegments[projectIndex] || null;
}
